import type { TOptions, TPlayer } from 'video.js'

import { Events } from '|>/shared/events'
import './plugin'

export type { DolbyPlugin, DolbyPluginOptions } from './plugin/index'

/**
 * Dolby detect configuration
 */
export type DolbyConfiguration = {
  /** Enable Dolby detection and UI (from content.dolbyAtmosAvailable) */
  enabled?: boolean
  /** Prefer Dolby when auto-selecting track (from isDolbyAtmosPreferred) */
  preferDolbyAtmos?: boolean
}

/**
 * Key to store chromecast configuration in player options
 */
const dolbyKey = '~~dolby'

/**
 * Configure Dolby detect plugin before player initialization
 */
export function configure(configuration?: DolbyConfiguration) {
  return (options: TOptions): TOptions => {
    // store configuration in player options
    options[dolbyKey] = configuration || {}

    return options
  }
}

/**
 * Injects Dolby detect
 */
export function inject(player: TPlayer): TPlayer {
  player.on(
    Events.Player.UpdateConfiguration,
    (_, configuration?: { dolby?: DolbyConfiguration }) => {
      const cfg = configuration?.dolby || {}
      player.options_[dolbyKey] = cfg
    }
  )

  const cfg = player.options_[dolbyKey] || {}
  player.dolby(cfg)

  return player
}
